
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 525.499 219.341"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"header slide 1"}},[_c('path',{attrs:{"data-name":"Path 7005","d":"M523.499 46.949V16.034H190.051","fill":"none","stroke":"#fff","stroke-width":"4"}}),_c('path',{attrs:{"data-name":"Path 7095","d":"M47.345 14.5H2.001v155.077","fill":"none","stroke":"#fff","stroke-width":"4"}}),_c('path',{attrs:{"data-name":"Path 7006","d":"M2.001 146.191v71.149h521.5v-71.149","fill":"none","stroke":"#fff","stroke-width":"4"}}),_c('text',{attrs:{"data-name":"since 1997","transform":"translate(62.198 20)","fill":"#fff","font-size":"20","font-family":"Barlow-MediumItalic, Barlow","font-weight":"500","font-style":"italic","letter-spacing":".109em"}},[_c('tspan',{attrs:{"x":"0","y":"0"}},[_v('SINCE 1997')])])])])
          )
        }
      }
    